import Api from './baseApi';

export default {
  getAll: () => Api.get('/api/marketplacePaymentRules'),
  get: (id) => Api.get(`/api/marketplacePaymentRules/${id}`),
  post: (rule) => Api.post('/api/marketplacePaymentRules', rule),
  put: (rule) => Api.put(`/api/marketplacePaymentRules/${rule.id}`, rule),
  delete: (id) => Api.delete(`/api/marketplacePaymentRules/${id}`),
};
